
// const RecadastramentoStepForm =
// [
//     {
//         key: 1,
//         validateAllForms: false,
//         mainStep: "GuideStep",
//         description: "Guia de Preenchimento",
//         steps: [
//             { name: "GuideForm"},
//         ]
//     },
//     {
//         key: 2,
//         validateAllForms: false,
//         mainStep: "PersonalAddressDataStep",
//         description: "Dados Pessoais e Endereço",
//         steps: [
//             { name: "PersonalDataForm" },
//             { name: "AddressDataForm" }
//         ]
//     },
//     {
//         key: 3,
//         validateAllForms: false,
//         mainStep: "BusinessAddressDataStep",
//         description: "Endereço Comercial",
//         steps: [
//             { name: "BusinessDataForm" },
//             { name: "BusinessAddressDataForm" }
//         ]
//     },
//     {
//         key: 4,
//         validateAllForms: true,
//         mainStep: "AcademicDegreeVocationalTraningStep",
//         description: "Dados Profissionais e Acadêmicos",
//         steps: [
//             { name: "ReRegistrationVocationalTrainingForm" },
//             { name: "ReRegistrationAcademicDegreeForm" },
//             { name: "ReRegistrationCourseForm" },
//             { name: "ReRegistrationMedicalLinkForm" },
//         ]
//     },
//     {
//         key: 5,
//         validateAllForms: false,
//         description: "Equipe Médica",
//         mainStep: "MedicalTeamStep",
//         steps: [
//             { name: "ReRegistrationTeamMembersForm" },
//             { name: "ReRegistrationProfessionalTeamForm" },
//         ]
//     },
//     {
//         key: 6,
//         validateAllForms: false,
//         description: "Escopo de Atuação",
//         mainStep: "ProfessionalPrivilegeStep",
//         steps: [
//             { name: "ReRegistrationProfessionalPrivilegeForm" },
//         ]
//     },
//     {
//         key: 7,
//         validateAllForms: false,
//         description: "Anexos",
//         mainStep: "ReRegistrationAttachmentDataStep",
//         steps: [
//             { name: "AttachmentForm" },
//         ]
//     }

// ];


// export { RecadastramentoStepForm };

const RecadastramentoStepForm =
[
    {
        key: 1,
        validateAllForms: false,
        mainStep: "GuideStep",
        description: "Guia de Preenchimento",
        steps: [
            { name: "GuideForm"},
        ]
    },
    {
        key: 2,
        validateAllForms: false,
        mainStep: "PersonalAddressDataStep",
        description: "Dados Pessoais e Endereço",
        steps: [
            { name: "PersonalDataForm" },
            { name: "AddressDataForm" }
        ]
    },
    {
        key: 3,
        validateAllForms: false,
        mainStep: "BusinessAddressDataStep",
        description: "Endereço Comercial",
        steps: [
            { name: "BusinessDataForm" },
            { name: "BusinessAddressDataForm" }
        ]
    },
    {
        key: 4,
        validateAllForms: false,
        description: "Anexos",
        mainStep: "ReRegistrationAttachmentDataStep",
        steps: [
            { name: "AttachmentForm" },
        ]
    }

];


export { RecadastramentoStepForm };